var pym = require("./lib/pym");
var { isMobile } = require("./lib/breakpoints");
require("./lib/webfonts");

var d3 = {
  ...require("d3-array/dist/d3-array.min")
}

// Global vars
var pymChild = null;
var renderDotChartMultiple = require("./renderDotChartMultiple");
const { formatDate } = require("./lib/helpers");
const formatters = require("./lib/helpers/formatDate");

// Initialize the graphic.
var onWindowLoaded = function () {
  if (document.body.classList.contains('promo')) {
    isPromo = true;
  }

  var series = formatData(window.DATA, window.LABELS)
  render(series);
  window.addEventListener("resize", () => render(series));

  pym.then(child => {
    pymChild = child;
    pymChild.sendHeight();
  });
};

var formatData = function(data, labels) {
  // console.log(data)
  // console.log(labels)

  //format dates
  data.forEach(function(d) {
    if (d.date instanceof Date) return;
    var [m, day, y] = d.date.split("/").map(Number);
    y = y > 50 ? 1900 + y : 2000 + y;
    d.date = new Date(y, m-1, day);
  })

  // get min/max dates
  var dates = []
  data.forEach(function(d) {
    dates.push(d.date)
  })
  var sorted_dates = dates.sort((a,b) => a-b)

  //group by maker
  var grouped = d3.groups(data, (d) => d.maker)

  var elections = []

  grouped.forEach( function(d) {

    var row = {
      "label": labels[d[0].toLowerCase()],
      "maker": d.shift(),
      "elections": d[0]
    }

    elections.push(row)

  })

  var formattedData = {"dateMin": sorted_dates[0], "dateMax": sorted_dates[sorted_dates.length - 1], "data": elections}
  
  return formattedData
}

// Render the graphic(s). Called by pym with the container width.
var render = function (data) {
  var electionsData = data["data"]
  
  // Render the chart!
  var container = "#dot-chart-multiple";
  var element = document.querySelector(container);
  element.innerHTML = "";
  var width = element.offsetWidth;

  // draw the charts
  if (isMobile.matches) {
    for (var i = 0; i < electionsData.length; i++) {
      var chartDiv = document.createElement('div');
      chartDiv.className = 'chart chart-' + i;
      element.appendChild(chartDiv);

      // Render the chart!
      renderDotChartMultiple({
        container: container + ' .chart-' + i,
        width,
        data: [electionsData[i]],
        idx: i,
        labelColumn: "label",
        minDate: data["dateMin"],
        maxDate: data["dateMax"],
      });
    }
  } else {
    // Render the chart!
    renderDotChartMultiple({
      container,
      width,
      data: electionsData,
      labelColumn: "label",
      minDate: data["dateMin"],
      maxDate: data["dateMax"],
    });
  }

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

/*
* Initially load the graphic
* (NB: Use window.load to ensure all images have loaded)
*/
window.onload = onWindowLoaded;
